import {
  Box,
  Grid,
  InputAdornment,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import React, { useEffect, useRef, useState } from "react";
import ModalHelper from "../../../Generics/ModalHelper";
import "../../../../assets/css/text.css";

const PaymentOperation = [
  {
    key: "Assegno bancario",
    labelIta: "Assegno bancario",
    labelEng: "Bank check",
  },
  {
    key: "Assegno circolare",
    labelIta: "Assegno circolare",
    labelEng: "Certified check",
  },
  {
    key: "Bonifico bancario",
    labelIta: "Bonifico bancario",
    labelEng: "Bank transfer",
  },
  {
    key: "Carta di credito",
    labelIta: "Carta di credito",
    labelEng: "Credit card",
  },
  {
    key: "Carta di debito",
    labelIta: "Carta di debito",
    labelEng: "Debit card",
  },
  {
    key: "Contanti (max €5.000,00)",
    labelIta: "Contanti (max €5.000,00)",
    labelEng: "Cash (max €5,000.00)",
  },
  {
    key: "Criptovalute",
    labelIta: "Criptovalute",
    labelEng: "Cryptocurrencies",
  },
  { key: "Paypal", labelIta: "Paypal", labelEng: "Paypal" },
];

const pt3 = { paddingTop: 2 };

const PrestazioneAmlGiuridico = ({
  languange,
  handleAmlUpdate,
  aml,
  errors = [],
  tooltipContent,
  natureOptions = [],
  fundsSourceOptions = [],
}) => {
  const [data, setData] = useState(
    aml?.service || {
      nature: "",
      payment_method: "",
      funds_source: "",
      nature_other: "",
      funds_source_other: "",
    },
  );

  const [natureSelect, setNatureSelect] = useState(aml?.service?.nature || "");
  const [natureSelectOpen, setNatureSelectOpen] = useState(false);
  const natureFromArrow = useRef(false);
  const [fundsSourceSelect, setFundsSourceSelect] = useState(
    aml?.service?.funds_source || "",
  );
  const [fundsSourceSelectOpen, setFundsSourceSelectOpen] = useState(false);
  const fundsSourceFromArrow = useRef(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalObjectInfo, setModalObjectInfo] = useState({});

  useEffect(() => {
    if (typeof handleAmlUpdate === "function") {
      handleAmlUpdate({ ...aml, service: data });
    }
  }, [data]);

  const t = (eng, ita) => (languange === "ENG" ? eng : ita);
  const ph = t("Insert", "Inserisci");

  const onChange = (e) =>
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const onNatureSelectChange = (e) => {
    natureFromArrow.current = false;
    const val = e.target.value;
    setNatureSelect(val);
    if (val !== "other") {
      setData((prev) => ({ ...prev, nature: val, nature_other: "" }));
    } else {
      setData((prev) => ({ ...prev, nature: "other" }));
    }
  };

  const onNatureOtherChange = (e) =>
    setData((prev) => ({ ...prev, nature_other: e.target.value }));

  const onFundsSourceSelectChange = (e) => {
    fundsSourceFromArrow.current = false;
    const val = e.target.value;
    setFundsSourceSelect(val);
    if (val !== "other") {
      setData((prev) => ({ ...prev, funds_source: val, funds_source_other: "" }));
    } else {
      setData((prev) => ({ ...prev, funds_source: "other" }));
    }
  };

  const onFundsSourceOtherChange = (e) =>
    setData((prev) => ({ ...prev, funds_source_other: e.target.value }));

  const openModal = (info) => {
    setModalObjectInfo(info);
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setModalObjectInfo({});
  };

  return (
    <>
      <Grid
        xs={12}
        columnSpacing={4}
        rowSpacing={0}
        item
        container
        sx={{ display: "flex", justifyContent: { xs: "center", md: "start" } }}
      >
        <Grid item xs={11} md={6} lg={4} sx={pt3}>
          <Typography className="color-blue-dark title-input">
            {t(
              "Nature and purpose of the professional mandate required to LEXIA firm",
              "Natura e scopo della prestazione professionale richiesta allo Studio LEXIA",
            )}
          </Typography>
          {natureSelect !== "other" ? (
            <Select
              value={natureSelect}
              error={errors.includes("service.nature") && natureSelect === ""}
              onChange={onNatureSelectChange}
              open={natureSelectOpen}
              onOpen={() => setNatureSelectOpen(true)}
              onClose={() => {
                setNatureSelectOpen(false);
                natureFromArrow.current = false;
              }}
              displayEmpty
              fullWidth
              MenuProps={{ PaperProps: { sx: { "& .MuiMenuItem-root": { whiteSpace: "normal" } } } }}
            >
              <MenuItem value="">
                <span style={{ color: "#abb0b6" }}>{t("Select", "Seleziona")}</span>
              </MenuItem>
              {natureOptions.filter((o) => o.value !== "other").map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
              <MenuItem value="other">{t("Other", "Altro")}</MenuItem>
            </Select>
          ) : (
            <TextField
              name="nature_other"
              value={data.nature_other || ""}
              error={errors.includes("service.nature_other")}
              onChange={onNatureOtherChange}
              placeholder={ph}
              fullWidth
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <ArrowDropDownIcon
                      style={{ cursor: "pointer", color: "rgba(0,0,0,0.54)" }}
                      onClick={() => {
                        natureFromArrow.current = true;
                        setNatureSelect("");
                        setData((prev) => ({ ...prev, nature: "", nature_other: "" }));
                        setNatureSelectOpen(true);
                      }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          )}
        </Grid>

        <Grid item xs={11} md={6} lg={4} sx={pt3}>
          <Typography className="color-blue-dark title-input">
            {t(
              "Payment instrument used for the payment of the transaction",
              "Mezzo di pagamento utilizzato per il pagamento dell'operazione",
            )}
          </Typography>
          <Select
            name="payment_method"
            value={data.payment_method || ""}
            error={errors.includes("service.payment_method")}
            onChange={onChange}
            displayEmpty
            fullWidth
          >
            <MenuItem value="">
              <span style={{ color: "#abb0b6" }}>Seleziona</span>
            </MenuItem>
            {PaymentOperation.map((item, i) => (
              <MenuItem key={i} value={item.key}>
                {t(item.labelEng, item.labelIta)}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        <Grid item xs={11} md={6} lg={4} sx={pt3}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography className="color-blue-dark title-input">
              {t(
                "Source(s) of funds used for the transaction",
                "Fonte/i di provenienza dei fondi impiegati per l'operazione",
              )}
            </Typography>
            <Box
              className="icon-modal-info-helper"
              style={{
                marginLeft: "10px",
                cursor: "pointer",
                flexShrink: 0,
                marginTop: "-8px",
              }}
              onClick={() =>
                openModal(t(tooltipContent.fonteEng, tooltipContent.fonteIta))
              }
            />
          </div>
          {fundsSourceSelect !== "other" ? (
            <Select
              value={fundsSourceSelect}
              error={
                errors.includes("service.funds_source") &&
                fundsSourceSelect === ""
              }
              onChange={onFundsSourceSelectChange}
              open={fundsSourceSelectOpen}
              onOpen={() => setFundsSourceSelectOpen(true)}
              onClose={() => {
                setFundsSourceSelectOpen(false);
                fundsSourceFromArrow.current = false;
              }}
              displayEmpty
              fullWidth
              MenuProps={{ PaperProps: { sx: { "& .MuiMenuItem-root": { whiteSpace: "normal" } } } }}
            >
              <MenuItem value="">
                <span style={{ color: "#abb0b6" }}>Seleziona</span>
              </MenuItem>
              {fundsSourceOptions.filter((o) => o.value !== "other").map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
              <MenuItem value="other">{t("Other", "Altro")}</MenuItem>
            </Select>
          ) : (
            <TextField
              name="funds_source_other"
              value={data.funds_source_other || ""}
              error={errors.includes("service.funds_source_other")}
              onChange={onFundsSourceOtherChange}
              placeholder={ph}
              fullWidth
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <ArrowDropDownIcon
                      style={{ cursor: "pointer", color: "rgba(0,0,0,0.54)" }}
                      onClick={() => {
                        fundsSourceFromArrow.current = true;
                        setFundsSourceSelect("");
                        setData((prev) => ({ ...prev, funds_source: "", funds_source_other: "" }));
                        setFundsSourceSelectOpen(true);
                      }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          )}
        </Grid>
      </Grid>

      <Modal open={modalOpen} onClose={closeModal}>
        <div>
          <ModalHelper
            onClose={closeModal}
            modalObjectInfo={modalObjectInfo}
            fullWidth={true}
          />
        </div>
      </Modal>
    </>
  );
};

export default PrestazioneAmlGiuridico;
